var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17 3h-10c-1.10457 0-2 .89543-2 2v14c0 1.1046.89543 2 2 2h6c3.3137 0 6-2.6863 6-6v-10c0-1.10457-.8954-2-2-2z",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 8h5m-5 4h4m-4 4h1",
    stroke: "#39d8b0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentation);
export default __webpack_public_path__ + "static/media/documentation.46796fe15034cb1c57f38a3f52255d65.svg";
export { ForwardRef as ReactComponent };